var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"text-left",attrs:{"id":_vm.id,"title":'Resolve Account Details',"toggle":_vm.closeModal}},[_c('ResolveAccountForm',{attrs:{"loading":_vm.loading,"closeModal":_vm.closeModal,"formSubmit":_vm.next,"account_number":_vm.acctNumber}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }